import React, { useContext } from "react";
import { StandardCase } from "@src/lms/jelly/extensions/layouts/standard-case/StandardCase";
import { useBlocks, useUi } from "@jelly/lesson";
import { Accordion, AccordionItem } from "@src/lms/jelly/extensions/ui";
import { useIntl } from "react-intl";
import { AccordionContext } from "@src/lms/jelly/extensions/ui/accordion/AccordionContext";

import { messages } from "../../VirtualAcoustics.messages";
import styles from "./Slide3.module.scss";

export const Slide3: React.FC = () => {
  return (
    <Accordion allowMultiOpen={false} defaultOpen={["accordionItem1"]}>
      <Slide3Content />
    </Accordion>
  );
};

const Slide3Content: React.FC = () => {
  const ui = useUi();
  const { formatMessage } = useIntl();

  const context = useContext(AccordionContext);
  const block = useBlocks();

  const accordion = (
    <div className={styles.accordion}>
      <ui.Scrollbars>
        <AccordionItem
          id={"accordionItem1"}
          title={formatMessage(messages.G6_P5_S3_Theory_Dropdown1_Title)}
          unmountChildrenWhenHidden
        >
          <p>{formatMessage(messages.G6_P5_S3_Theory_Dropdown1_Description)}</p>
        </AccordionItem>
        <AccordionItem
          id={"accordionItem2"}
          title={formatMessage(messages.G6_P5_S3_Theory_Dropdown2_Title)}
          unmountChildrenWhenHidden
        >
          <p>{formatMessage(messages.G6_P5_S3_Theory_Dropdown2_Description)}</p>
        </AccordionItem>
      </ui.Scrollbars>
    </div>
  );

  const renderRightComponent = (): React.ReactNode => {
    if (context.openIds.includes("accordionItem1")) {
      return (
        <>
          <h3>{formatMessage(messages.G6_P5_S3_Theory_Dropdown1_ImageTitle)}</h3>
          <block.video src="https://youtu.be/QkqHuSKGzYU" provider="youtube" />
          <p className={styles.caption}>{formatMessage(messages.G6_P5_S3_Theory_Image_Caption)}</p>
        </>
      );
    }
    if (context.openIds.includes("accordionItem2")) {
      return (
        <>
          <h3>{formatMessage(messages.G6_P5_S3_Theory_Dropdown2_ImageTitle)}</h3>
          <p>{formatMessage(messages.G6_P5_S3_Theory_Dropdown2_Image_Header)}</p>
          <block.video src="https://youtu.be/JUhdhDx4FXs" provider="youtube" />
          <p className={styles.caption}>{formatMessage(messages.G6_P5_S3_Theory_Image_Caption)}</p>
        </>
      );
    }

    return null;
  };

  return (
    <div className={styles.root}>
      <StandardCase title={formatMessage(messages.G6_P5_S2_Title)} leftComponent={accordion}>
        <div className={styles.rightComponent}>{renderRightComponent()}</div>
      </StandardCase>
    </div>
  );
};
